import { useQuery } from '@tanstack/react-query';
import DataApiClient from 'src/utils/DataApiClient';
import { JsonObject } from 'cerializr';
import { Serializer } from '@drift/common';
import OrderRecordAndActionStateHandler from '../utils/OrderRecordAndActionMatcher';
import { MAX_RECENT_TRADES_TO_CACHE } from '../constants/constants';

export const useMarketRecentTradesCache = (
	marketSymbol: string | undefined
) => {
	return useQuery({
		queryKey: ['market-recent-trades', marketSymbol],
		queryFn: async () => {
			try {
				const pageOneTradesResult =
					await DataApiClient.fetchShortTermData<JsonObject>(
						'recentMarketTrades',
						undefined,
						{
							marketSymbol,
							limit: 50,
						}
					);

				const deserializedNewTrades = pageOneTradesResult.records.map((t) =>
					Serializer.Deserialize.DataApiUIOrderActionRecord(t)
				);

				const sortedDedupedTrades =
					OrderRecordAndActionStateHandler.getSortedDedupedTrimmedRecords(
						deserializedNewTrades,
						MAX_RECENT_TRADES_TO_CACHE
					);

				return {
					records: sortedDedupedTrades,
				};
			} catch (error) {
				console.error('Error fetching market recent trades:', error);
				throw error; // Re-throw to let React Query handle it
			}
		},
		enabled: !!marketSymbol,
		staleTime: 5 * 1000, // This can't be large - because it creates room for inconsistency between candles and recent trades if the user switches between markets. Essentially want to pick a happy medium where it would be rare for user to switch between markets A=>B=>A in less than the staleTime. A PROPER solution would be us refactoring the store to just start caching all trades that come through the pipe once we're connected. We only fetch recent trades from our infra when we detect that the currently selected market doesn't have the required amount of history.
	});
};
